export default "__VITE_ASSET__DjtYv9DX__"